



























































































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IUser, EUserStatus, EUserGroup, IDialog } from "@/components/shared/types";
import { User } from "@/components/User";
import { L } from "@/common/filters";
import { isString, isObject, isEmptyObject, sortObjectArray } from "@/common/utils";
import { ICodeList } from "@/components/map/types";
const AddressMapping = {
    hrn_pk: 'addrHrn',
    door_no: 'addrNo',
    vill_no: 'addrMoo',
    vill_th: 'addrVill',
    floor_nn: 'addrFloor',
    building_th: 'addrBuilding',
    alley_th: 'addrAlley',
    street_th: 'addrStreet',
    addr_aa3: 'addrProvince',
    addr_aa4: 'addrCounty',
    addr_aa5: 'addrTown',
    zip_code: 'addrZipCode'
  };

@Component({
})
export default class UserRegistration extends Vue {
  showMini:boolean = true;
  errorMessage:string = null;

  name:string = null;
  surname:string = null;
  nationalId:string = null;
  mobileNo:string = null;
  email:string = null;

  addrHrn:number = null;
  addrNo:string = null;
  addrMoo:string = null;
  addrVill:string = null;
  addrBuilding:string = null;
  addrFloor:number = null;
  addrAlley:string = null;
  addrStreet:string = null;
  addrProvince:number = null;
  addrCounty:number = null;
  addrTown:number = null;
  addrZipCode:number = null;

  userId:string = null;
  password:string = null;
  password2:string = null;
  
  Provinces: ICodeList[] = [];
  addrCounties: ICodeList[] = [];
  addrTowns: ICodeList[] = [];

  ssnChecking:boolean = false;
  emailChecking:boolean = false;
  mobileChecking:boolean = false;
  usernameChecking:boolean = false;
  ssnError:string[] = [];
  emailError:string[] = [];
  mobileError:string[] = [];
  usernameError:string[] = [];

  sending:boolean = false;
  sent:boolean = false;

  async checkAvailability(name:"ssn" | "email" | "mobile" | "username",value:string) {
    this[name + 'Error'] = [];
    if (value) {
      try {
        this[name + 'Checking'] = true;
        let parmas = {};
        parmas[name] = value;
        let available = await this.User.requestResource('user/availability', 'GET', parmas);
        this[name + 'Checking'] = false;
        if (!available[name]) {
          this[name + 'Error'].push(L('alreadyRegistered'));
        } else if (name=='ssn') {
          this.fetchPerson();
        }
      } catch (error) {
        this[name + 'Checking'] = false;
        this[name + 'Error'].push(error.message || 'Check Error');
      }
    }
  }

  get rules() {
    return {
      required: value => {
        value = value ? (value+'').trim() : null;
        return !!value || L('required');
      },
      email: value => {
        this.emailError = [];
        let valid:boolean = this.User.validateEmail(value);
        if (valid) {
          this.checkAvailability('email',value);
        }
        return valid || L(!value ? 'required' : 'invalidEmail');
      },
      username: value => {
        value = value ? (value+'').trim() : null;
        let valid:boolean = !!value && (value.length>=4) && (value.length<=12);
        this.usernameError = [];
        if (valid) {
          this.checkAvailability('username',value);
        }
        return valid || L(!value ? 'required' : 'invalidUsername');
      },
      password: value => {
        //allow password to contain space
        return (!!value && value.length>=6) || L(!value ? 'required' : 'invalidPassword');
      },
      password2: value => {
        return ((!!value || !!this.password) && value==this.password) || 
                L(!value ? 'required' : 'passwordNotTheSame');
      },
      ssn: value => {
        this.ssnError = [];
        value = value ? (value+'').trim() : null;
        let valid = this.User.validateThaiId(value);
        if (valid) {
          this.checkAvailability('ssn',value);
        }
        return valid || L(!value ? 'required' : 'invalidSSN');
      },
      mobile: value => {
        this.mobileError = [];
        value = value ? (value+'').trim() : null;
        if (!value) return true;
        let valid:boolean = !!value && (value.length==10);
        if (valid) {
          this.checkAvailability('mobile',value);
        }
        return valid || L(!value ? 'required' : 'invalidMobileNo');
      }
    }
  }
  
  created() {
    this.fetchProvinces();
  }

  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  get Dialog() : IDialog {
    return this.$store.getters.Dialog;
  }

  get hasValidMobileNo() {
    let mn = this.mobileNo;
    return !mn || this.User.validateMobile(mn);
  }

  get hasValidUserInput() : boolean {
    let name = this.name ? this.name.trim() : null;
    let surname = this.surname ? this.surname.trim() : null;
    return !!name && !!surname && 
           !!this.userId && this.userId.trim().length>=4 && 
           !!this.password && this.password.trim().length>=6 && 
           this.password==this.password2 && 
           !!this.nationalId && this.User.validateThaiId(this.nationalId) && 
           this.hasValidMobileNo && 
           this.User.validateEmail(this.email) &&
           !this.ssnChecking && this.ssnError.length==0 &&
           !this.emailChecking && this.emailError.length==0 &&
           !this.mobileChecking && this.mobileError.length==0;
  }

  get hasChanged() : boolean {
    // set to null so that null==undefine is true
    // ''==undefined is false
    [ 'name','surname','nationalId','mobileNo']
    .forEach((p) => {
      this[p] = !!this[p] ? this[p] : null;
    });
    return this.hasValidUserInput
  }

  get User() : User {
    return this.$store.getters.User;
  }

  get language() : string {
    return this.$store.getters.Language;
  };

  async fetchPerson() {
    let address = {};
    try {
      if (this.nationalId) {
        let farmers = await this.User.requestResource('mis/farmer/' + this.nationalId);
        let farmer = farmers[0];
        this.name = farmer.name_th;
        this.surname = farmer.surname_th;
        if (farmer.mobile) {
          this.mobileNo = farmer.mobile;
          this.rules.mobile(this.mobileNo);
        }
        if (farmer.email) {
          this.email = farmer.email;
          this.rules.email(this.email);
        }
        address = farmer.address || {};
      }
    } catch (error) {}
    for (let p in AddressMapping) {
      this[AddressMapping[p]] = address[p] || null;
    }
  }

  async fetchProvinces() {
    try {
      if (this.Provinces && this.Provinces.length>0) return;
      let data = await this.User.requestResource('codelist/province');
      this.Provinces = data.map((d) => {
        return d;
      });
    } catch (error) {}
  };

  async fetchCounties() {
    try {
      let exists:boolean = false;
      this.addrCounties = [];
      this.addrTowns = [];
      if (this.addrProvince) {
        let data = await this.User.requestResource('codelist/amphoe/' + this.addrProvince);
        this.addrCounties = data.map((d) => {
          exists = exists || (this.addrCounty==d.code);
          return d;
        });
      }
      if (!this.addrProvince || !exists) {
        this.addrCounty = null;
        this.addrTown = null;
        this.addrZipCode = null;
      }
    } catch (error) {
    }
  };

  async fetchTowns() {
    try {
      let exists:boolean = false;
      this.addrTowns = [];
      if (this.addrCounty) {
        let data = await this.User.requestResource('codelist/tambon/' + this.addrCounty);
        this.addrTowns = data.map((d) => {
          exists = exists || (this.addrTown==d.code);
          return d;
        });
      }
      if (!this.addrCounty || !exists) {
        this.addrTown = null;
      }
      if (!this.addrTown) {
        this.addrZipCode = null;
      }
    } catch (error) {
    }
  };

  onProvinceChange() {
    this.fetchCounties();
  };

  onCountyChange() {
    this.fetchTowns();
  };

  onTownChange() {
    if (this.addrTown) {
      for (let i=0; i<this.addrTowns.length; i++) {
        if ((this.addrTowns[i].code==this.addrTown) && this.addrTowns[i].zip_code) {
          this.addrZipCode = parseInt(this.addrTowns[i].zip_code+'');
        }
      }
    } else {
      this.addrZipCode = null;
    }
  }

  async validateForm() {
    try {
      let form = this.$refs.form;
      if (form['validate']) {
        await form['validate'](); // this is a Promise
      }
    } catch (error) {}
  }

  updateProfileAfterSave() {
    this.ssnChecking = false;
    this.emailChecking = false;
    this.mobileChecking = false;
    this.usernameChecking = false;
    this.ssnError = [];
    this.emailError = [];
    this.mobileError = [];
    this.usernameError = [];
  }

  async saveUser() {
    try {
      this.sending = true;
      /*this.$store.commit('notifyChange', {
        Dialog: {
          Type: 'info',
          Title: 'registerUsers',
          Message: null,
          OkText: null,
          CancelText: 'close',
          wait: true,
          OnClose: null
        }
      });*/
      let me:User = new User({
        GivenName: this.name,
        Surname: this.surname
      });

      let method:"POST" | "PUT";
      let address:{[key:string] : any} = {};
      for (let p in AddressMapping) {
        if (!p.match(/addr_aa3|addr_aa4|addr_aa5|hrn_pk/) && this[AddressMapping[p]]) {
          address[p] = this[AddressMapping[p]];
        }
      }
      let aac = this.addrTown || this.addrCounty || this.addrProvince;
      if (!!aac) {
        address['aac5_fk'] = aac;
      }
      if (!isEmptyObject(address)) {
        address.user_fk = this.User.HalloId;
        if (this.addrHrn) {
          method = 'PUT';
          address.hrn_pk = this.addrHrn;
        } else {
          method = 'POST';
        }
        address = await this.User.requestResource('mis/address', method, address);
      } else if (this.addrHrn) {
        await this.User.requestResource('mis/address', 'DELETE', {
          hrn_pk: this.addrHrn
        });
        address = null;
      }
      let farmer:{[key:string] : any} = {
        user_fk: this.User.HalloId
      };
      
      let ssn = isString(this.nationalId) ? 
          parseFloat(this.nationalId) : this.nationalId;
      method = 'PUT';
      farmer['ssn_pk'] = ssn;
      farmer['name_' + this.language] = this.name;
      farmer['surname_' + this.language] = this.surname;
      farmer['email'] = this.email;
      farmer['mobile'] = this.mobileNo;
      if (address && address.keyname && address[address.keyname]) {
        farmer.hrn_fk = address[address.keyname];
      } else {
        farmer.hrn_fk = null;
      }
      farmer = await this.User.requestResource('mis/farmer', method, farmer);
      let user = {
        name_on: this.name,
        surname: this.surname,
        ssn: ssn,
        email: this.email,
        mobile: this.mobileNo,
        uname: this.userId,
        upswd: this.password,
        ugroup: EUserGroup.Citizens,
        orgc_fk: null,
        aor_code: null
      };
      user = await this.User.requestResource('user','POST', user);
      let $this = this;

      this.updateProfileAfterSave();

      /*this.$store.commit('notifyChange', {
        Dialog: {
          Type: 'info',
          Title: 'registerUsers',
          Message: 'registerAnotherUser',
          wait: false,
          show: false
        }
      });*/
      this.sending = false;
    } catch (error) {
      this.sending = false;
      this.$store.commit('notifyChange', {
        Dialog: {
          Type: 'error',
          Title: 'error',
          Message: error.message || 'Error during registration',
          OkText: null,
          CancelText: 'close',
          show: true,
          OnClose: null
        }
      });
    }
  }

  backToLogin() {
    this.$emit('changeMenu',{
      name: 'login'
    });
  }
}
